import { render, staticRenderFns } from "./EntityPagination.vue?vue&type=template&id=2295f77a&"
import script from "./EntityPagination.vue?vue&type=script&lang=ts&"
export * from "./EntityPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports